module.exports = __webpack_public_path__ + "50dd06b5343438d637eab0e0792a1821.MP3";